import type { ScheduleEditorWidget } from '../../../widgets';
import {
  BindingRow,
  CheckboxField,
  OptionalBindingRow,
  Section,
  SelectField,
  patcher,
  type WidgetEditorProps,
} from '../fields';

/** Gaengige Rasterweiten. 15 und 30 Minuten decken die Regler ab, 60 ist fuer
 *  Programme gedacht, die ohnehin nur stundenweise schalten. */
const STEPS = [
  { value: '15', label: '15 Minuten' },
  { value: '30', label: '30 Minuten' },
  { value: '60', label: '60 Minuten' },
];

export function ScheduleEditorEditor(
  { widget, plantId, onChange }: WidgetEditorProps<ScheduleEditorWidget>,
) {
  const patch = patcher(widget, onChange);
  return (
    <>
      <Section title="Bindung">
        <BindingRow
          label="Programm-Datenpunkt"
          value={widget.programPoint}
          plantId={plantId}
          // Nur schreibbar verlangen, solange das Widget auch schreiben darf.
          // Ein Nur-Lese-Wochenprogramm an einem Lesepunkt ist voellig in
          // Ordnung, und ein Filter, der ihn ausblendet, waere im Weg.
          filter={widget.readOnly ? undefined : { writable: true }}
          hint="Der reglereigene Programm-Punkt. Inhalt und Format kommen vom Regler."
          onChange={(next) => patch({ programPoint: next })}
        />
        <OptionalBindingRow
          label="Ferien-Datenpunkt"
          value={widget.holidayPoint}
          plantId={plantId}
          hint="Wird als Überlagerung über die Woche gelegt."
          onChange={(next) => patch({ holidayPoint: next })}
        />
      </Section>
      <Section title="Raster">
        <SelectField
          label="Minuten je Zelle"
          value={String(widget.gridStepMinutes ?? 15)}
          options={STEPS}
          onChange={(next) => patch({ gridStepMinutes: Number(next) })}
        />
        <CheckboxField
          label="Nur ansehen"
          checked={widget.readOnly}
          hint="Eingeschaltet kann der Bediener das Programm lesen, aber nicht verstellen."
          onChange={(next) => patch({ readOnly: next })}
        />
      </Section>
    </>
  );
}
